<template>
  <div>
    <Loader></Loader>
    <v-app-bar app :style="getThemeStyle" height="75" dark>
      <v-avatar class="mr-3" color="grey lighten-5" size="70">
        <v-img
          contain
          max-height="60%"
          :src="
            getApiUrl + '/images/logos/' + getUserCompany.emis + '/' + images[0]
          "
        ></v-img>
      </v-avatar>

      <v-toolbar-title class="font-weight-black headline">
        {{ getUserCompany.name }}
        <br />
        <SwitchCompany
          :userId="getCurrentUser.id"
          v-if="getUserCompany && getUserCompany.emis != 'hands-of-hope-2022'"
        ></SwitchCompany>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down" :style="getThemeStyle">
        <span
          v-for="(item, i) in menu"
          :key="i + Math.random() + Math.random()"
        >
          <v-btn
            v-if="
              getAuthenticated &&
              (item.route == 'switchboard' ||
                item.route == 'company-website' ||
                item.route == 'web-store' ||
                item.route == 'contact-us' ||
                item.route == 'events-calendar' ||
                item.route == 'images-gallery')
            "
            text
            :style="getThemeStyle"
            :to="{ name: item.route }"
          >
            <v-icon left>{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-btn>
          <v-btn
            v-else-if="
              !getAuthenticated &&
              (item.route == 'company-website' ||
                item.route == 'home' ||
                item.route == 'register' ||
                item.route == 'login' ||
                item.route == 'web-store' ||
                item.route == 'contact-us' ||
                item.route == 'events-calendar' ||
                item.route == 'images-gallery')
            "
            text
            :style="getThemeStyle"
            :to="{ name: item.route }"
          >
            <v-icon left>{{ item.icon }}</v-icon>
            <span>{{ item.title }}</span>
          </v-btn>
        </span>

        <v-btn
          v-if="
            !getAuthenticated &&
            getUserCompany &&
            getUserCompany.emis == 'hands-of-hope-2022'
          "
          text
          rounded
          :style="{ color: getSecondaryColor, display: 'block' }"
          @click="signIn()"
        >
          <v-icon left>mdi-account</v-icon>
          <span>Sign In</span>
        </v-btn>
        <v-btn
          v-if="getAuthenticated"
          text
          rounded
          :style="getThemeStyle"
          @click="signOut()"
        >
          <v-icon left @click="signOut()">exit_to_app</v-icon>
          <span>Sign Out</span>
        </v-btn>
      </div>

      <div class="hidden-md-and-up">
        <v-row>
          <v-menu transition="slide-x-transition" bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                fab
                dark
                v-bind="attrs"
                v-on="on"
                :style="getThemeStyle"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>

            <v-list
              :style="{
                'background-color': getThemeColor,
                color: getSecondaryColor,
                opacity: 0.7,
              }"
            >
              <br />
              <br />
              <br />
              <v-layout
                v-for="(item, i) in menu"
                :key="i + Math.random() + Math.random()"
                class="justify-left"
              >
                <v-btn
                  v-if="
                    getAuthenticated &&
                    (item.route == 'switchboard' ||
                      item.route == 'web-store' ||
                      item.route == 'contact-us' ||
                      item.route == 'events-calendar' ||
                      (item.route == 'company-website' && notSameRoute()) ||
                      item.route == 'images-gallery')
                  "
                  text
                  :style="{ color: getSecondaryColor, display: 'block' }"
                  :to="{ name: item.route }"
                >
                  <v-icon left>{{ item.icon }}</v-icon>
                  <span>{{ item.title }}</span>
                </v-btn>
                <v-btn
                  v-else-if="
                    (item.route == 'company-website' && notSameRoute()) ||
                    item.route == 'home' ||
                    item.route == 'register' ||
                    item.route == 'login' ||
                    item.route == 'web-store' ||
                    item.route == 'contact-us' ||
                    item.route == 'events-calendar' ||
                    item.route == 'images-gallery'
                  "
                  text
                  :style="{ color: getSecondaryColor, display: 'block' }"
                  :to="{ name: item.route }"
                >
                  <v-icon left>{{ item.icon }}</v-icon>
                  <span>{{ item.title }}</span>
                </v-btn>
              </v-layout>

              <v-btn
                v-if="
                  !getAuthenticated &&
                  getUserCompany &&
                  getUserCompany.emis == 'hands-of-hope-2022'
                "
                text
                rounded
                :style="{ color: getSecondaryColor, display: 'block' }"
                @click="signIn()"
              >
                <v-icon left>mdi-account</v-icon>
                <span>Sign In</span>
              </v-btn>
              <v-btn
                v-if="getAuthenticated"
                text
                rounded
                :style="{ color: getSecondaryColor, display: 'block' }"
                @click="signOut()"
              >
                <v-icon left @click="signOut()">exit_to_app</v-icon>
                <span>Sign Out</span>
              </v-btn>
            </v-list>
          </v-menu>
        </v-row>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import SwitchCompany from "@/components/myLibrary/SwitchCompany.vue";
import Loader from "@/components/Loader.vue";

export default {
  components: { SwitchCompany, Loader },

  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    itsBitsems() {
      return this.$store.getters.itsBitsems;
    },
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    this.$store.commit("setLoader", true);
    if (
      localStorage.getItem("token") != null &&
      localStorage.getItem("authenticated") != null
    ) {
      this.$store.commit("setAccessToken", localStorage.getItem("token"));
      this.$store.commit("setAuthenticated", true);
    }
    let domain = "";
    domain = window.location.hostname;

    axios
      .postData("/get-company-website-banner", { domain })
      .then((websiteBanners) => {
        if (websiteBanners[0]) {
          this.$emit("get-website-banner", websiteBanners[0]);
        } else {
          this.$emit("get-website-banner", null);
        }

        axios.postData("/get-company-with-domain", { domain }).then((data) => {
          //console.log(data.company.labels);
          if (data.legal_services) {
            this.$emit("legal-services", data.legal_services);
          }
          this.$emit("get-company", data.company);
          if (data.ip_info && data.ip_info.currencyCode) {
            this.$store.commit("setCurrency", data.ip_info.currencyCode);
            localStorage.setItem("currency", data.ip_info.currencyCode);
          }
          //  else {
          //   this.$store.commit("setCurrency", data.company.currency);
          //   localStorage.setItem("currency", data.company.currency);
          // }
          this.$store.commit("setUserCompany", data.company);
          this.$store.commit("setCompanyLabels", data.company.labels);
          this.$store.commit("setThemeColor", data.company.primary_bg_color);
          this.$store.commit(
            "setSecondaryColor",
            data.company.secondary_bg_color
          );
          this.$store.commit("setAppName", data.company.name);
          //this.$store.commit("setSiteArticles", data.posts);
          // this.$store.commit("setSiteStats", data.stats);

          localStorage.setItem("themeColor", data.company.primary_bg_color);
          localStorage.setItem(
            "secondaryColor",
            data.company.secondary_bg_color
          );

          localStorage.setItem("appName", data.company.name);
          localStorage.setItem("userCompany", JSON.stringify(data.company));
          localStorage.setItem(
            "companyLabels",
            JSON.stringify(data.company.labels)
          );

          this.getLogos(data.company.emis);
          this.$store.commit("setLoader", false);
        });
      });
  },
  data() {
    return {
      drawer: null,
      images: [],
      menu: [
        {
          icon: "mdi-home",
          title: "Home",
          description: "",
          color: "deep-orange darken-4",
          route: "home",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        // {
        //   icon: "mdi-store",
        //   title: "Store",
        //   description: "",
        //   color: "deep-orange darken-4",
        //   route: "web-store",
        //   buttonText: "Enter",
        //   alevel: 1,
        //   param: "",
        // },

        {
          icon: "apps",
          title: "Switchboard",
          description: "",
          color: "deep-orange darken-4",
          route: "switchboard",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "mdi-account",
          title: "Sign In",
          description: "",
          color: "deep-orange darken-4",
          route: "login",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        {
          icon: "exit_to_app",
          title: "Register",
          description: "",
          color: "deep-orange darken-4",
          route: "register",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
        // {
        //   icon: "mdi-play-box-multiple",
        //   title: "Gallery",
        //   description: "",
        //   color: "deep-orange darken-4",
        //   route: "images-gallery",
        //   buttonText: "Enter",
        //   alevel: 1,
        //   param: "",
        // },
        // {
        //   icon: "mdi-calendar",
        //   title: "Events",
        //   description: "",
        //   color: "deep-orange darken-4",
        //   route: "events-calendar",
        //   buttonText: "Enter",
        //   alevel: 1,
        //   param: "",
        // },
        {
          icon: "mdi-phone",
          title: "Contact Us",
          description: "",
          color: "deep-orange darken-4",
          route: "contact-us",
          buttonText: "Enter",
          alevel: 1,
          param: "",
        },
      ],
    };
  },
  methods: {
    getLogos(emis) {
      axios
        .postData("/get-logos-for-given-company", {
          folder: "logos",
          emis: emis,
        })
        .then((images) => {
          this.images = images;
          if (images && images.length > 0) {
            this.$store.commit(
              "setLogo",
              this.getApiUrl +
                "/images/logos/" +
                this.getUserCompany.emis +
                "/" +
                images[0]
            );
            localStorage.setItem(
              "logo",
              this.getApiUrl +
                "/images/logos/" +
                this.getUserCompany.emis +
                "/" +
                images[0]
            );
          }
        });
    },
    signOut() {
      axios
        .postDataWithToken("/auth/logout", {}, this.getAccessToken)
        .then((response) => {
          this.$store.commit("setAuthenticated", false);
          this.$store.commit("setCurrentUser", {});
          localStorage.clear();
          if (window.location.pathname == "/") {
            window.location.reload();
          } else {
            this.$router.push({ path: "/" });
          }
        });
    },
    signIn() {
      this.$emit("show-login");
    },
    notSameRoute() {
      if (window.location.pathname != "/") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style></style>
